import { AuthUserType } from "../shared/types"

export type JWTAuthData = {
  readonly id: string
  readonly expiresAt: number
  readonly type: AuthUserType
  readonly ownerId: string | null
}

export const extractData = (jwt: string): JWTAuthData => {
  const payload = jwt.split(`.`)[1]
  const cleaned = payload.replace(/-/g, `+`).replace(/_/g, `/`)
  const parsed = JSON.parse(window.atob(cleaned))
  const claim = parsed[`https://platform.flock.com/user`]

  if (claim !== undefined) {
    return {
      id: claim.id,
      expiresAt: parsed.exp,
      type: makeModernAuthUserType(claim.kind),
      ownerId: claim.ownerId ?? null,
    }
  }

  return {
    id: parsed.sub,
    expiresAt: parsed.exp,
    type: makeAuthUserType(parsed.typ),
    ownerId: parsed.oid ?? null,
  }
}

export const isDataValid = (data: JWTAuthData): boolean => data.expiresAt * 1000 > Date.now()

function makeAuthUserType(type: string): AuthUserType {
  switch (type) {
    case `introducer`:
      return `distributor` as AuthUserType
    case `broker`:
      return `admin` as AuthUserType
    case `customer`:
      return `customer` as AuthUserType
    case `claims_admin`:
      return `claims_admin` as AuthUserType
    case `carrier`:
      return `carrier` as AuthUserType
    default:
      return `customer` as AuthUserType
  }
}

function makeModernAuthUserType(type: string): AuthUserType {
  switch (type) {
    case `broker`:
      return `distributor` as AuthUserType
    case `flocker`:
      return `admin` as AuthUserType
    case `customer`:
      return `customer` as AuthUserType
    case `claims_admin`:
      return `claims_admin` as AuthUserType
    case `carrier`:
      return `carrier` as AuthUserType
    default:
      return `customer` as AuthUserType
  }
}
